var OnboardingCheckListActionId = /* @__PURE__ */ function(OnboardingCheckListActionId2) {
  OnboardingCheckListActionId2["WATCH_YOUTUBE_VIDEO"] = "watch-youtube-video";
  OnboardingCheckListActionId2["INSTALL_NATIVE_APPS"] = "install-native-apps";
  OnboardingCheckListActionId2["UPLOAD_FIRST_FILE"] = "upload-first-file";
  OnboardingCheckListActionId2["CREATE_FIRST_NOTEPAD"] = "create-first-notepad";
  OnboardingCheckListActionId2["SAVE_FIRST_LINK"] = "save-first-link";
  OnboardingCheckListActionId2["ASK_AI_SOMETHING"] = "ask-ai-something";
  OnboardingCheckListActionId2["ADD_FIRST_CONNECTION"] = "add-first-connection";
  OnboardingCheckListActionId2["TRY_AI_SEARCH"] = "try-ai-search";
  OnboardingCheckListActionId2["CHECKOUT_FABRIC_GUIDE"] = "checkout-fabric-guide";
  return OnboardingCheckListActionId2;
}(OnboardingCheckListActionId || {});
var CheckListItemType = /* @__PURE__ */ function(CheckListItemType2) {
  CheckListItemType2["LINK"] = "link";
  CheckListItemType2["TASK"] = "task";
  return CheckListItemType2;
}(CheckListItemType || {});

export { CheckListItemType, OnboardingCheckListActionId };
//# sourceMappingURL=index.js.map
